<template>
    <form @submit.prevent="login">
        <div class="form-group">
            <label>Username</label>
            <input v-model="model.username" type="text" class="form-control" placeholder="Enter Your username">
        </div>
        <div class="form-group">
            <div class="d-flex justify-content-between mg-b-5">
                <label class="mg-b-0-f">Password</label>
                <router-link to="/reset-password" class="tx-13">Forgot password?</router-link>
            </div>

            <input v-model="model.password" type="password" class="form-control" placeholder="Enter your password">
            <base-button
                    class="mt-3"
                    :loading="auth.authLoading"
                    title="Sign In"
            ></base-button>

        </div>
    </form>
</template>

<script>
    import BaseButton from "../button/BaseButton";
    import {mapState} from 'vuex';
    export default {
        name: "LogonForm",
        components: {
            BaseButton
        },
        data() {
            return {
                model: {
                    username: '',
                    password: ''
                },
            }
        },
        methods: {
            clicked(){
                this.$swal({
                    title: 'Custom animation with Animate.css',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                })
            },
            async login() {
                localStorage.clear();
                console.log(this.auth.authLoading);
                await this.$store.dispatch("auth/logon", this.model, { root: false }).then(
                    result => {
                        if (result.responsecode === "00") {
                            localStorage.token = result.jwt;
                            this.$router.push("/");
                        } else if(result.responsecode === "33"){
                            this.$router.push("/reset-password");
                        }
                        this.$swal({
                            title: result.responsecode === "00" ? `Success` : `Error!`,
                            text: result.responsemessage,
                            icon: result.responsecode === "00" ? `success` : 'warning',
                            confirmButtonText: 'OK',
                            type: "error"
                        });
                    }
                );



                // console.log(this.auth.response);
               // await this.$store.dispatch('system/updateUserInfo',null,{root:false})
               //

                // console.log(this.auth.authLoading)


            },

            async passwordReset1() {
                await this.$store.dispatch("auth/initiateResetPassword", this.model, { root: false })
            },

            async passwordReset2() {
                await this.$store.dispatch("auth/verifyToken", this.model, { root: false })
            },

            async passwordReset3() {
                await this.$store.dispatch("auth/completeResetPassword", this.model, { root: false })
            },
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'auth',
                'officer',
            ]),

        },

        watch: {
            'auth': function() {
                console.log('Hello World!')
            }
        },
        mounted() {
            // this.$store.auth.watch(this.$store.getters.getN, n => {
            //     console.log('watched: ', n)
            // })
        },
    }
</script>

<style scoped>

</style>
